import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigService } from './config.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./config.service";
export class CategoryService {
    constructor(http, configService) {
        this.http = http;
        this.configService = configService;
        this.jsonContent = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': sessionStorage.getItem('batoken'),
                'User': sessionStorage.getItem('userid')
            })
        };
    }
    listWithFocos() {
        const headers = new HttpHeaders({ Authorization: sessionStorage.getItem('batoken') });
        return this.http.get(`${this.configService.API_URL}/categories/with-focos`, { headers }).toPromise();
    }
    update(user, categoriaId) {
        return this.http.put(`${this.configService.API_URL}/categories/${categoriaId}`, user, Object.assign({}, this.jsonContent, { responseType: 'text' })).toPromise();
    }
    create(user) {
        return this.http.post(`${this.configService.API_URL}/categories`, user, Object.assign({}, this.jsonContent, { responseType: 'text' })).toPromise();
    }
    getAllCategorias() {
        const headers = new HttpHeaders({ Authorization: sessionStorage.getItem('batoken') });
        return this.http.get(`${this.configService.API_URL}/categories/todas`, { headers }).toPromise();
    }
    getByIdCategorias(id) {
        const headers = new HttpHeaders({ Authorization: sessionStorage.getItem('batoken') });
        return this.http.get(`${this.configService.API_URL}/categories/listaById?id=${id}`, { headers }).toPromise();
    }
    estaHabilitado(user) {
        const headers = new HttpHeaders({ Authorization: sessionStorage.getItem('batoken') });
        return this.http.get(`${this.configService.API_URL}/capacitaciones/empresa-habilitada?userid=${user}`, { headers }).toPromise();
    }
    deleteCategoria(idCategoria) {
        return this.http.delete(`${this.configService.API_URL}/categories/${idCategoria}`, Object.assign({}, this.jsonContent, { responseType: 'json' })).toPromise();
    }
}
CategoryService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CategoryService_Factory() { return new CategoryService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.ConfigService)); }, token: CategoryService, providedIn: "root" });
